(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('GatewayDiagnosticsController', GatewayDiagnosticsController);

    GatewayDiagnosticsController.$inject = ['$scope', '$state', 'TkbTransfer'];

    function GatewayDiagnosticsController($scope, $state, TkbTransfer) {
        var vm = this;

        vm.search = search;
        vm.onChangeMethod = onChangeMethod;
        vm.copyRequest = copyRequest;
        vm.copyResponse = copyResponse;
        vm.serviceInfoId = "11628";
        vm.serviceId = "11629";
        vm.transferAmount = 3000;
        vm.paymentAmount = 100000;
        vm.searchQuery = {
            merchant: 'GLOBIZ',
            gateway: 'TKB',
            method: "checkCardReceipt",
            referenceId: null,
            externalId: null,
            serviceId: "11629",
            account: "977580843",
            cardNumber: "8600312905180812",
            visaCardNumber: "4278320021072383",
            amount: 3000,
            margin: 'true',
            receiverFirstName: 'KHAMIDULLO',
            receiverLastName: 'PIRMATOV'
        }

        function search() {
            TkbTransfer.getGatewayDiagnostics({
                merchant: vm.searchQuery.merchant,
                gateway: vm.searchQuery.gateway,
                method: vm.searchQuery.method,
                referenceId: vm.searchQuery.referenceId,
                externalId: vm.searchQuery.externalId,
                serviceId: vm.searchQuery.serviceId,
                account: vm.searchQuery.account,
                cardNumber: vm.searchQuery.cardNumber,
                visaCardNumber: vm.searchQuery.visaCardNumber,
                amount: vm.searchQuery.amount,
                margin: vm.searchQuery.margin,
                receiverFirstName: vm.searchQuery.receiverFirstName,
                receiverLastName: vm.searchQuery.receiverLastName
            }, onSuccess, onError);
            function onSuccess(data) {
                vm.request = data.requestBody;
                vm.response = data.responseBody;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function onChangeMethod() {
            vm.searchQuery.amount = (vm.searchQuery.method === 'createTransfer' || vm.searchQuery.method === 'createTransferVisa') ? vm.transferAmount : vm.paymentAmount;
            vm.searchQuery.serviceId = vm.searchQuery.method === 'getPaymentInformation' ? vm.serviceInfoId : vm.serviceId;
        }

         function copyRequest() {
            var jsonElement = document.getElementById("requestJson");

            if (jsonElement) {
                var range = document.createRange();
                range.selectNode(jsonElement);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);

                try {
                    document.execCommand("copy");
                    AlertService.success("JSON copied successfully");
                } catch (err) {
                    AlertService.error("Error coping JSON");
                }

                window.getSelection().removeAllRanges();
            }
        }

        function copyResponse() {
            var jsonElement = document.getElementById("responseJson");

            if (jsonElement) {
                var range = document.createRange();
                range.selectNode(jsonElement);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);

                try {
                    document.execCommand("copy");
                    AlertService.success("JSON copied successfully");
                } catch (err) {
                    AlertService.error("Error coping JSON");
                }
                window.getSelection().removeAllRanges();
            }
        }
    }
})();
